export const environment = {
  app: 'local',
  apiUrlDb: 'http://localhost:4000',
  appCode: 'AFFILIATE',
};